export const sexOptions = [
	{ id: 'HOMBRE', name: 'Hombre' },
	{ id: 'MUJER', name: 'Mujer' },
	{ id: 'NO_BINARIO', name: 'No binario' },
];
